import type { FaireProductEntity } from "../../entity_types/product";

export const p_jjvs5qsqym: FaireProductEntity = {
  token: "p_jjvs5qsqym",
  type: "product",
  name: "Heavenly heart Necklace - Moonstone",
  brandToken: "b_2ki6r755",
  brandName: "JOY DRAVECKY JEWELRY",
  imageUrl:
    "https://cdn.faire.com/fastly/2a37543abbca57f1d4b67913de173037a57ec986d4b0dee982bef67bcbe91516.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8084427ebc8bee349cad08fe0a9ee4c5d05b7904d644ae62532d2d1b09d2b248.jpeg",
    "https://cdn.faire.com/fastly/bfe418d748cd3608f3a84ac06a473b9405f6a37e51749d7f40f6fd7dcc757dc0.jpeg",
    "https://cdn.faire.com/fastly/fa950d9e7610980e7c50b6dc0a65155abc99a9c2c7c1a1cf57d401b5c2668743.jpeg",
  ],
  priceDollars: 56,
  description:
    'Show your love with this eye-catching heart necklace featuring a pink shell center with sparkling CZ accents on a dainty chain.\n\nFeatures: Pendant style, heart charm, Rainbow Moonstone inlay, 14k gold plated box chain 16" + 2" extender, cubic zirconia accents, adjustable clasp closure\n\n\nWhy We <3 It: This sweet piece is perfect for adding a touch of sparkle to your neck.\n',
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:45.917Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
